import {
  ComponentPropsWithoutRef,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import AssetCover from "./AssetCover.tsx";
import styles from "./AssetCoverSized.module.scss";
import { clsx } from "clsx";

/**
 * If you think you need to square the corners, check with design.
 * When it has come up thus far they have said square corners are design errors
 * and should be rounded
 */
export default function AssetCoverSized({
  className,
  ...props
}: Omit<ComponentPropsWithoutRef<typeof AssetCover>, "onLoad">) {
  const imageRef = useRef<HTMLImageElement>(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const onImageLoaded = useCallback(() => {
    setIsImageLoaded(true);
  }, []);

  const loadedImageAspectRatio = useMemo(() => {
    if (imageRef.current && isImageLoaded) {
      return imageRef.current.naturalWidth / imageRef.current.naturalHeight;
    }
  }, [isImageLoaded]);

  const needsContain = loadedImageAspectRatio && loadedImageAspectRatio >= 1;

  return (
    <div
      className={clsx(
        styles.imageContainer,
        needsContain && styles.contain,
        className
      )}
    >
      <AssetCover {...props} onLoad={onImageLoaded} ref={imageRef} />
    </div>
  );
}
